export const newsList = [
  {
    id: "n1",
    title: "《流浪地球3》定档国庆，预告片单日播放量破亿",
    summary:
      "备受期待的科幻巨制《流浪地球3》正式宣布定档国庆档，首支预告片上线后单日播放量迅速突破一亿，行星发动机的最终形态首次完整曝光。",
    date: "2026-09-28",
    author: "91蜜桃编辑部",
    category: "影片动态",
    content: [
      "备受期待的科幻巨制《流浪地球3》正式宣布定档国庆档。片方于昨日发布了首支正式预告片，短短二十四小时内播放量便突破一亿次，相关话题接连登上热搜榜前列。",
      "预告片首次完整展示了行星发动机的最终形态，以及人类联合政府在国际空间站场景下的关键决策。导演林寒在采访中表示，第三部将把系列的世界观推向一个更辽阔也更残酷的维度。",
      "据片方透露，影片在视效制作上投入了超过三年的周期，仅行星发动机的建模就经历了数十次迭代。不少业内人士认为，这一部将成为华语科幻工业化水准的又一次集中展示。",
      "目前影片已开启预售，多个城市的零点场次在开票后迅速售罄。91蜜桃将持续关注该片后续的路演与口碑表现。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=sci-fi%20film%20premiere%20news%20photo%2C%20giant%20glowing%20film%20poster%20on%20the%20facade%20of%20a%20modern%20cinema%20at%20night%2C%20crowd%20of%20fans%20and%20camera%20flashes%2C%20cinematic%20urban%20atmosphere%2C%20editorial%20news%20image&width=800&height=450&seq=nw-n1-91peach&orientation=landscape",
  },
  {
    id: "n2",
    title: "2026年度华语电影十佳榜单新鲜出炉",
    summary:
      "由数十位影评人与行业观察者共同评选的年度华语电影十佳榜单正式公布，多部中小成本作品凭借扎实的叙事与真诚的表达入围前列。",
    date: "2026-09-20",
    author: "影评人 · 沈默",
    category: "年度盘点",
    content: [
      "年度华语电影十佳榜单于本周正式揭晓。与往年不同，今年的榜单呈现出明显的“去流量化”趋势，多部中小成本作品凭借扎实的剧本与真诚的表达赢得评委一致认可。",
      "位列榜首的是现实主义题材影片《逆流而上》，该片以克制而细腻的镜头语言，讲述了一位普通工人在时代变化中的坚守与选择，被评价为“近年来最动人的小人物群像”。",
      "科幻与悬疑类型同样表现亮眼，《深空回响》与《迷雾追凶》分别占据第二、第三位，显示出观众对类型片品质的要求正在不断提高。",
      "多位评委在采访中提到，今年华语电影最大的进步在于叙事自信——创作者越来越敢于讲述属于自己的故事，而不是简单模仿海外类型片的套路。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=film%20awards%20ceremony%20news%20image%2C%20elegant%20golden%20trophy%20on%20a%20red%20velvet%20stage%20with%20spotlights%20and%20scattered%20confetti%2C%20glamorous%20editorial%20photography%2C%20warm%20cinematic%20tones&width=800&height=450&seq=nw-n2-91peach&orientation=landscape",
  },
  {
    id: "n3",
    title: "悬疑剧《风暴之眼》口碑逆袭，评分持续走高",
    summary:
      "开播时并不被看好的悬疑剧《风暴之眼》，凭借扎实的剧本与演员的精彩表演实现口碑逆袭，评分已稳步攀升至年度剧集前列。",
    date: "2026-09-15",
    author: "91蜜桃编辑部",
    category: "剧集观察",
    content: [
      "悬疑剧《风暴之眼》播出过半后迎来口碑爆发。开播初期该剧因节奏偏慢受到部分观众质疑，但随着关键线索逐步铺开，剧情张力全面释放，评分也随之稳步攀升。",
      "剧中对于小城群像的刻画被观众反复讨论，多位配角的命运线与主线案件形成巧妙呼应，被认为是“近年少见的、真正把悬疑当作人物剧来写的作品”。",
      "导演五百在采访中提到，创作时最想做的其实是“让观众关心这些人，而不只是关心凶手是谁”。这一思路也解释了该剧为何在类型框架下依然保有温度。",
      "目前该剧已进入收官阶段，最后两集被普遍认为是决定其能否进入年度最佳的关键。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=tv%20drama%20trending%20news%20image%2C%20cozy%20living%20room%20scene%20with%20a%20glowing%20television%20screen%20showing%20a%20mysterious%20dark%20forest%2C%20moody%20evening%20light%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=nw-n3-91peach&orientation=landscape",
  },
  {
    id: "n4",
    title: "综艺市场新风向：慢生活类节目为何持续走红",
    summary:
      "从田园客栈到乡野厨房，慢生活类综艺持续占据话题中心。它们的走红，折射出观众在快节奏生活中对松弛感的强烈渴望。",
    date: "2026-09-08",
    author: "传媒观察 · 林一",
    category: "行业观察",
    content: [
      "近两年，慢生活类综艺在市场上的表现格外抢眼。不再依赖强冲突与密集笑点，这类节目把镜头对准做饭、聊天、晒太阳的日常瞬间，却意外收获了大批忠实观众。",
      "业内人士分析，慢综艺的走红与当下观众的情绪需求密切相关。在高强度的工作与信息过载之外，人们更需要一种“可以被允许慢下来”的观看体验。",
      "与此同时，节目制作的逻辑也在发生变化。相比设计复杂任务，制作团队如今更注重场景的选择与真实反应的捕捉，让嘉宾在自然状态中呈现真实的一面。",
      "不过也有观点提醒，慢综艺一旦陷入同质化，同样会面临审美疲劳。如何在“慢”与“有意思”之间找到平衡，将是下一步的关键。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=variety%20show%20trend%20news%20image%2C%20film%20crew%20and%20cameras%20filming%20a%20cheerful%20outdoor%20variety%20program%20in%20a%20sunny%20meadow%2C%20bright%20natural%20daylight%2C%20documentary%20style%20editorial%20photo&width=800&height=450&seq=nw-n4-91peach&orientation=landscape",
  },
  {
    id: "n5",
    title: "经典重映热潮：那些年我们追过的老电影",
    summary:
      "越来越多的经典影片以修复版形式重返大银幕，观众在熟悉的画面里重温旧梦，也见证着电影修复技术这些年的进步。",
    date: "2026-08-30",
    author: "91蜜桃编辑部",
    category: "经典重温",
    content: [
      "今年以来，多部经典影片以修复版的形式重返大银幕，其中不少场次在上映首周便接近满座。对许多观众而言，走进影院重看老片，更像是一场与过去自己的重逢。",
      "修复团队介绍，一部旧片的修复往往需要经历画面扫描、色彩校正、音频重建等多个环节，部分胶片甚至需要逐帧清理划痕与噪点，工作量远超普通观众的想象。",
      "重映热的背后，也反映出观众对“确定的好内容”的信任。在信息快速更替的当下，那些经得起时间检验的作品，反而成为了稀缺品。",
      "有院线人士表示，未来将会有更多经典影片以主题展映的形式与观众见面，为不同年龄层的观众提供走进影院的新理由。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=classic%20film%20re-release%20news%20image%2C%20vintage%20film%20reels%20and%20old%20cinema%20seats%20bathed%20in%20warm%20projector%20light%2C%20nostalgic%20retro%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=nw-n5-91peach&orientation=landscape",
  },
  {
    id: "n6",
    title: "影视行业观察：短剧崛起背后的内容逻辑",
    summary:
      "单集只有几分钟的短剧，正以惊人的速度改变着内容消费的节奏。它究竟是一阵风，还是一种会长期存在的新形态？",
    date: "2026-08-22",
    author: "行业评论 · 顾远",
    category: "行业观察",
    content: [
      "在过去的一年里，短剧成为内容行业增长最快的品类之一。单集只有几分钟、节奏紧凑、强钩子密集的叙事方式，迅速占据了大量用户的碎片时间。",
      "支持者认为，短剧的兴起本质上是内容消费习惯变化的自然结果——在注意力愈发稀缺的今天，能够在前三十秒抓住观众，本身就是一种能力。",
      "但也有从业者提醒，短剧的工业化生产容易导致题材扎堆与套路化。如果只追求即时爽感而忽视人物与主题，热度很可能难以持续。",
      "可以预见的是，短剧与传统长剧之间并非替代关系。两者面对的是不同的观看场景，而真正决定成败的，依然是内容本身是否足够真诚。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=short%20drama%20industry%20news%20image%2C%20smartphone%20on%20a%20stand%20filming%20a%20small%20vertical%20drama%20set%20with%20softbox%20lights%2C%20modern%20content%20production%20scene%2C%20clean%20bright%20editorial%20photo&width=800&height=450&seq=nw-n6-91peach&orientation=landscape",
  },
];